import { Card } from 'antd';
import React, { createContext, type ReactNode, useContext, useEffect, useState } from 'react';
import { SegmentedTabs } from '../../../components/segmented-tabs';
import { AuthContext } from '../../../contexts/auth-context-provider';
import { Customer } from '../../../entities';
import { Roles } from '../../../types';

const CustomerFormLazy = React.lazy(async () => await import('./customer.form'));
const CustomerSettingFormLazy = React.lazy(async () => await import('./customer-setting.form'));
const UsersComponentLazy = React.lazy(async () => await import('./customer-users.component'));
const SitesComponentLazy = React.lazy(async () => await import('./customer-sites.component'));
const InvoiceConfigurationsComponentLazy = React.lazy(
  async () => await import('././customer-invoice-configurations.component')
);

export const CustomerContext = createContext<Customer>(new Customer());

const CustomerFormTabsComponent = ({
  customer,
  onConfirm,
  onCancel,
}: {
  customer: Customer;
  onConfirm: (customer: Customer, close: boolean) => void;
  onCancel: () => void;
}): ReactNode => {
  const { session } = useContext(AuthContext);
  const [editedCustomer, setEditedCustomer] = useState<Customer>(customer);
  const [tabActiveKey, _] = useState('0');
  useEffect(() => {
    setEditedCustomer(customer);
  }, [customer]);

  return (
    <Card style={{ width: '100%' }} styles={{ body: { padding: 0 } }}>
      <SegmentedTabs activeKey={tabActiveKey}>
        <SegmentedTabs.TabPane label="Information" value="0">
          <CustomerFormLazy onConfirm={onConfirm} onCancel={onCancel} customer={editedCustomer} />
        </SegmentedTabs.TabPane>
        <SegmentedTabs.TabPane
          label="Settings"
          value="1"
          disabled={!editedCustomer.id}
          hidden={session?.claims.role !== Roles.ROLE_HHC_ADMIN}
        >
          <CustomerSettingFormLazy onCancel={onCancel} customer={editedCustomer} />
        </SegmentedTabs.TabPane>
        <SegmentedTabs.TabPane label="Users" value="2" disabled={!editedCustomer.id}>
          <UsersComponentLazy onCancel={onCancel} customer={editedCustomer} />
        </SegmentedTabs.TabPane>
        <SegmentedTabs.TabPane
          label="Sites"
          value="3"
          disabled={!editedCustomer.id}
          hidden={session?.claims.role !== Roles.ROLE_HHC_ADMIN}
        >
          <SitesComponentLazy onCancel={onCancel} customer={editedCustomer} />
        </SegmentedTabs.TabPane>
        <SegmentedTabs.TabPane
          label="Invoice Configurations"
          value="4"
          disabled={!editedCustomer.id}
          hidden={session?.claims.role !== Roles.ROLE_HHC_ADMIN}
        >
          <InvoiceConfigurationsComponentLazy onCancel={onCancel} customer={editedCustomer} />
        </SegmentedTabs.TabPane>
      </SegmentedTabs>
    </Card>
  );
};

export default CustomerFormTabsComponent;
